const TTL_MS = 30_000

interface Entry {
  promise: Promise<unknown>
  startedAt: number
}

const entries = new Map<string, Entry>()

function live(key: string): Entry | undefined {
  const entry = entries.get(key)
  if (!entry) {
    return undefined
  }
  if (Date.now() - entry.startedAt > TTL_MS) {
    entries.delete(key)
    return undefined
  }
  return entry
}

export function prefetch<T>(key: string, fetcher: () => Promise<T>): void {
  if (live(key)) {
    return
  }
  const promise = fetcher()
  promise.catch(() => undefined)
  entries.set(key, { promise, startedAt: Date.now() })
}

export function takePrefetched<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
  const entry = live(key)
  if (!entry) {
    return fetcher()
  }
  entries.delete(key)
  return entry.promise as Promise<T>
}

export function clearPrefetched(): void {
  entries.clear()
}
